// extracted by mini-css-extract-plugin
export default {"root":"Error__root___TRz2C","text":"Error__text___gF1UA","button":"Error__button___Mpl7c"};